import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "aliwer_cookie_consent";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch {
      /* ignore */
    }
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch {
      /* ignore */
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 z-[70] max-w-md rounded-2xl border border-white/15 bg-[#0d0d0f]/95 backdrop-blur-xl p-5 shadow-2xl"
      data-testid="cookie-consent"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="flex items-start gap-3">
        <Cookie size={18} className="text-paper mt-0.5 shrink-0" />
        <div>
          <p className="text-sm text-paper/90 leading-relaxed">
            We use essential cookies to run this site and optional analytics to improve it.
            See our{" "}
            <Link to="/privacy" className="underline hover:text-paper">Privacy Policy</Link>.
          </p>
          <div className="mt-4 flex items-center gap-2">
            <button
              onClick={() => decide("accepted")}
              data-testid="cookie-accept"
              className="rounded-full bg-paper text-black text-sm font-medium px-4 py-2 hover:bg-white transition-colors"
            >
              Accept
            </button>
            <button
              onClick={() => decide("declined")}
              data-testid="cookie-decline"
              className="rounded-full border border-white/20 text-paper text-sm font-medium px-4 py-2 hover:bg-white/5 transition-colors"
            >
              Decline
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
